module.exports = __webpack_public_path__ + "img/skip-source-phone2.58e82b46.png";